module.exports = __webpack_public_path__ + "img/avatar2.5bf8a80a.png";